import { Box, Grid, Typography } from '@mui/material'
import { styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Form, Formik } from 'formik'
import axios from 'axios'

import LoadingContext from 'Contexts/LoadingContext'
import ModalContext from 'Contexts/ModalContext'
import TextField from 'Components/TextField'

import schema from './schema'

const StyledButton = styled('button')(({ theme }) => ({
	border: 'none',
	borderRadius: '.375rem',
	padding: '.5rem 1rem',
	backgroundColor: 'rgb(37, 47, 63)',
	color: theme.palette.common.white,
	transition: '250ms',
	cursor: 'pointer',
	fontSize: '0.75rem',
	fontFamily: 'Work Sans,sans-serif',
	'&:hover': {
		backgroundColor: 'rgb(54, 166, 226)',
	},
}))

// Retry helper for handling transient network/connection issues
const retryRequest = async (fn, retries = 3, delay = 1000) => {
	for (let i = 0; i < retries; i++) {
		try {
			return await fn()
		} catch (error) {
			// If it's the last retry or a non-retryable error (like 404), throw immediately
			if (
				i === retries - 1 ||
				(error.response && error.response.status === 404)
			) {
				throw error
			}
			// Wait before retrying (exponential backoff)
			await new Promise((resolve) => setTimeout(resolve, delay * (i + 1)))
		}
	}
}

export default function SearchPage() {
	const navigate = useNavigate()

	return (
		<LoadingContext.Consumer>
			{({ setLoading }) => (
				<ModalContext.Consumer>
					{({ setModal }) => (
						<Box px={2} sx={{ py: { xs: 4, md: 8 } }}>
							<Formik
								initialValues={{
									gensetSerial: '',
								}}
								validationSchema={schema}
								onSubmit={async (values, { resetForm, setSubmitting }) => {
									setLoading(true)
									setSubmitting(true)

									retryRequest(() =>
										axios.post('/api/Home/SearchGetEquipDetailReturn', values, {
											headers: {
												'Content-Type': 'multipart/form-data',
											},
										})
									)
										.then(({ data }) => {
											if (!data) {
												setModal({
													title: 'No record found',
													body: (
														<div>
															<Typography>
																Sorry, that Serial is invalid or does not match
																our records. Please contact our service
																department for assistance by calling
																<br />
																<br />
																<a href="tel:18003240066,2">800-324-0066</a>
															</Typography>
														</div>
													),
													buttons: [
														{
															label: 'OK',
															onClick: () => {
																resetForm()
															},
														},
													],
												})
											} else {
												navigate(`/${data.gensetSerial}`)
											}
										})
										.catch((error) => {
											console.error('error creating', error)
											setModal({
												title: 'Error loading data',
												body: error.toString(),
											})
										})
										.finally(() => {
											setSubmitting(false)
											setLoading(false)
										})
								}}
							>
								{({ isSubmitting }) => (
									<Form>
										<Grid
											container
											alignItems="center"
											justifyContent="center"
											style={{ textAlign: 'center' }}
										>
											<Grid item>
												<Typography
													variant="h5"
													color="secondary.main"
													align="center"
												>
													<span style={{ fontWeight: 'bold' }}>Confirm</span>{' '}
													your generator&apos;s Serial as listed on the Clifford
													QR sticker.
												</Typography>
												<Box m={2}>
													<TextField
														fullWidth={false}
														name="gensetSerial"
														label="Serial"
													/>
												</Box>
												<StyledButton type="submit" disabled={isSubmitting}>
													CONFIRM
												</StyledButton>
											</Grid>
										</Grid>
									</Form>
								)}
							</Formik>
						</Box>
					)}
				</ModalContext.Consumer>
			)}
		</LoadingContext.Consumer>
	)
}

